module.exports = __webpack_public_path__ + "media/images/home/step_template_2nd-aff6530914f1c2618f2df79910e7a1fc.svg";